// extracted by mini-css-extract-plugin
export default {"root":"PlasmicBrandPerceptionBarChart_root__SoGqR","img__zQ2Ul":"PlasmicBrandPerceptionBarChart_img__zQ2Ul__02GqL"};